import { mapStores } from 'pinia';
import { h } from 'vue';

import ldRedirectMixin from '@/mixins/ldRedirect';
import { useFlagStore } from '@/stores/flag';

const LDRouteGuard = {
  mixins: [ldRedirectMixin()],
  props: {
    component: { type: [Function, Object, Promise], required: true },
    componentProps: { type: Object, required: false, default: () => {} },
    requiredFeatureFlag: { type: String, required: true },
    to: { type: [String, Object, Function], required: true },
    invertFlag: { type: Boolean, required: false, default: false },
  },
  computed: {
    ...mapStores(useFlagStore),
    show() {
      return this.flagStore.ready && this.ldRedirectFlagValue;
    },
    importedComponent() {
      // Handle dynamically imported components
      if (!!this.component && typeof this.component.then === 'function') {
        return () => this.component;
      }
      return this.component;
    },
  },
  created() {
    this.ldRedirectTo = this.to;
  },
  render() {
    if (this.show) {
      return h(this.importedComponent, { props: this.componentProps });
    }
    return null;
  },
};

export default LDRouteGuard;
